import Background from 'Components/Reusable/Background/Background';
import React, { Fragment } from 'react';
import { useStyles } from './resetPassword.style';
import * as yup from 'yup';
import { useFormik } from 'formik';
import resetPassword from 'Assets/img/svg/resetPassword/resetPassword.svg';
import { ReusableInput } from 'Components/Reusable/Inputs/ReusableInput';
import { CommonButton } from 'Components/Reusable/Buttons/Buttons';
import { useDispatch } from 'react-redux';
import { resetPasswordfun, forgetPassword, newPasswordfun } from 'ReduxStore/profile/Action';
import ConditionalCard from 'Components/Reusable/Cards/ConditionalCard';
import CustomModal from 'Components/Modals/CustomModal';
import { useHistory, useParams } from 'react-router-dom';

interface RouteParams {
	token: string;
}

interface State {

	newPassword: string;
	confirmPassword: string;
}

const validationSchema = yup.object({
	newPassword: yup
		.string()
		.min(8, 'Password should be of minimum 8 characters length')
		.required('Password is required'),
	confirmPassword: yup
		.string()
		.min(8, 'Password should be of minimum 8 characters length')
		.required('Password is required'),
});
import { Routes } from 'Utils/Route';
const NewPassword = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
    const params = useParams<RouteParams>();
	const history = useHistory();
	const [values, setValues] = React.useState<State>({
		newPassword: '',
		confirmPassword: '',
	});
	const conditions = [
		{id:1,name:'CONTINUE TO LOGIN'}
	]
	const formik = useFormik({
		initialValues: {
			newPassword: '',
			confirmPassword: '',
		},
		validationSchema: validationSchema,
		onSubmit: values => {
			// alert(JSON.stringify(values, null, 2));
			if (values.newPassword != values.confirmPassword){
				alert("OOPs kindly check on your new password")
			} else {
				dispatch(newPasswordfun(values.newPassword,params.token));
				setOpen(true);
			}
			
		},
	});

	const resetElements = [
		{
			id: 2,
			name: 'newPassword',
			label:"New password",
			type: 'password',
			placeholder: '',
		},
		{
			id: 3,
			name: 'confirmPassword',
			label:"Confirm password",
			type: 'password',
			placeholder: '',
		},
	];
	// const history = useHistory();
	const [open, setOpen] = React.useState(false);
	const handleOpen = () => {
		setOpen(true);
	};
	const handleModalClick = (condition: string) =>
		
		history.push(Routes.Login)

	const handleClose = () => {
		setOpen(false);
	};
	return (
		<Fragment>
			<Background middleItem={resetPassword} row height="100vh">
				<div className={`${classes.background} px-3 mx-auto d-flex`}>
					<img src={resetPassword} className={classes.imageLock} alt="" />
					<h6 className={`${classes.text} text-center py-2`}>Generate new Password</h6>
					<form onSubmit={formik.handleSubmit}>
						<ul className={`${classes.listItems} mb-3`}>
							{resetElements.map(element => (
								<li key={element.id} className="mt-2">
									<ReusableInput
										name={element.name}
										type={element.type}
										placeholder={element.placeholder}
										formik={formik}
										label={element.label}
										width="381.87px"
										height="53.91px"
									/>
								</li>
							))}
						</ul>
						<div className="d-flex justify-content-center align-items-center">
							<CommonButton
								command="UPDATE"
								common={{
									width: '381.87px',
									height: '48px',
									background: '#7FD6DD',
									radius: '200px',
									fontSize: '20px',
								}}
							/>
						</div>
					</form>
				</div>
				{open === true ? (
					<CustomModal open={open} handleClose={handleClose}>
						<ConditionalCard
							information="Your password has been successfully reset, continue to login"
							heading={`Password Reset!`}
							conditions={conditions}
							onClick={handleModalClick}
						/>
					</CustomModal>
				) : (
					''
				)}
			</Background>
		</Fragment>
	);
};

export default NewPassword;
